import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SupportPage } from '@/pages/support';
import { supportSearchSchema } from '@/routes/-shared/supportSearchSchema';

/**
 * Supporto: la lista dei propri ticket, con le route figlie (`/new`, `/$id`)
 * che aprono una `SheetView` sopra di essa. Nessun `RoleGuard`: è l'unica
 * sezione senza permessi — chi non può usare un modulo deve comunque poter
 * segnalare che è rotto.
 */
export const Route = createFileRoute('/protected/_layout/support/_layout')({
  validateSearch: supportSearchSchema,
  component: SupportLayout,
});

function SupportLayout() {
  return (
    <>
      <SupportPage />
      <Outlet />
    </>
  );
}
